import {
  FETCH_DS1_ALL_PRODUCT_FILTERS,
  RESET_DS1_ALL_PRODUCT_FILTERS,
} from "../../constants/action.constants";

const initialState = {
  brands: [],
  subBrands: [],
  categories: [],
  subCategories: [],
  states: [],
};

const ds1AllProductFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DS1_ALL_PRODUCT_FILTERS:
      return {
        brands: action.payload.brands || [],
        subBrands: action.payload.subBrands || [],
        categories: action.payload.categories || [],
        subCategories: action.payload.subCategories || [],
        states: action.payload.states || action.payload.statuses || [],
      };
    case RESET_DS1_ALL_PRODUCT_FILTERS:
      return initialState;
    default:
      return state;
  }
};

export default ds1AllProductFiltersReducer;
